
import { PDFArray, PDFName, PDFString, rgb } from 'pdf-lib';

export async function fetchUint8Array( path ) {

  return await fetch( path )
  
    .then( res => res.arrayBuffer() )
    
    .then( res => new Uint8Array( res ) );
  
}

function hexToRgb( value ) {
    
  return rgb( ( ( value & 0xff0000 ) >> 16 ) / 255, ( ( value & 0xff00 ) >> 8 ) / 255, ( value & 0xff ) / 255 );
  
}

function alignToTranslate( align, width, height ) {
  
  const offsets = {
  
    'left': { x: x => x },
    
    'right': { x: x => x - width },
    
    'top': { y: y => y + height },
  
    'bottom': { y: y => y }
    
  };
  
  return align.split( /\s+/ ).reduce(
    
    ( translate, token ) => ( { ...translate, ...offsets[ token ] } ),
    
    { x: x => x - width / 2, y: y => y + height / 2 }
  
  );
  
}

export function drawText( options ) {
  
  const { doc, page, font, maxWidth, maxHeight, size, x, y, align, color, ...rest } = {
    
    ...{ text: '', maxWidth: 0, maxHeight: 0, size: 12, x: 0, y: 0, align: 'center', color: 0x0 },
    
    ...options
  
  };

  const lineHeight = rest.lineHeight ?? font.heightAtSize( size );

  const maxLines = maxHeight > 0 ? Math.floor( maxHeight / lineHeight ) : Infinity;

  const lines = ( maxWidth > 0 ? rest.text.trim().split( /\n/ ).map( line => {

    const words = [];

    line.split( /\s+/ ).forEach( word => {

      const glyphs = [];

      let start = 0;

      let end = 0;
  
      while ( end < word.length ) {
  
        if ( font.widthOfTextAtSize( word.slice( start, ++ end ), size ) > maxWidth ) {
  
          glyphs.push( word.slice( start, end - 1 ) );
  
          start = end - 1;
  
        }
  
      }

      glyphs.push( word.slice( start, end ) );

      words.push( glyphs.join( '\n' ) );

    } );

    return words.join( ' ' ).split( /\n/ );

  } ).flat().map( line => {

    const lines = [];

    let words = [];

    line.split( /\s+/ ).forEach( word => {

      words.push( word );

      if ( font.widthOfTextAtSize( words.join( ' ' ), size ) > maxWidth ) {

        const lastWord = words.pop();

        lines.push( words.join( ' ' ) );

        words = [ lastWord ];

      }

    } );

    lines.push( words.join( ' ' ) );

    return lines;

  } ).flat() : [ rest.text ] ).slice( 0, maxLines );

  const text = lines.join( '\n' );

  const width = maxWidth > 0 ? maxWidth : font.widthOfTextAtSize( text, size );
  
  const height = lineHeight * lines.length;
  
  const offset = lineHeight * ( lines.length - 1 );
  
  const translate = alignToTranslate( align, width, height );
  
  const coordinates = { x: translate.x( x ), y: page.getHeight() - translate.y( y ) + offset };
  
  page.drawText( text, { font, size, lineHeight, x: coordinates.x, y: coordinates.y, color: hexToRgb( color ), ...rest } );
  
  if ( rest.url ) {
  
    const linkAnnot = doc.context.obj( {
      
      Type: 'Annot',
      
      Subtype: 'Link',
      
      Rect: [ coordinates.x, coordinates.y, coordinates.x + width, coordinates.y + height ],
      
      Border: [ 0, 0, 0 ],
      
      C: [ 0, 0, 0 ],
      
      A: { Type: 'Action', S: 'URI', URI: PDFString.of( rest.url ) }
      
    } );
    
    const linkAnnotRef = doc.context.register( linkAnnot );
    
    const annots = page.node.lookup( PDFName.of( 'Annots' ), PDFArray );
    
    annots.push( linkAnnotRef );
    
  }

  return { x, y, width, height };
  
}

export async function savePDF( name, doc ) {
  
  const bytes = await doc.save();
  
  const anchor = document.createElement( 'a' );
  
  anchor.href = URL.createObjectURL( new Blob( [ new Uint8Array( bytes ) ], { type: 'application/pdf' } ) );
  
  anchor.download = `${ name }.pdf`;
  
  anchor.click();
  
}
